import { FC, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

import DataTable from 'components/tables/data-table';
import { useAuth } from 'contexts';
import { defaultTransactionColumns, transactionDataColumns } from 'pages/transactions/grid/transaction-columns';
import { downloadTransactionsCsv, fetchTransactionsWithSpecifcation } from 'services';
import { Role } from 'types';

const UnitTransactions: FC<{ unitNumber?: string | null }> = ({ unitNumber }) => {
  const params = useParams();
  const { userProfile } = useAuth();

  const [deleted, setDeleted] = useState<false | undefined>(
    [Role.ADMIN, Role.BILLING_ADMIN, Role.BOOKING].includes(userProfile.role) ? undefined : false
  );

  const fetchData = useMemo(
    () => fetchTransactionsWithSpecifcation({ unitNumber: unitNumber ?? undefined, deleted }),
    [unitNumber, deleted]
  );

  const initialColumns = useMemo(() => {
    return userProfile.columnPreferences.filter(cp => cp.table === 'TRANSACTION').length > 0
      ? userProfile.columnPreferences
          .filter(cp => cp.table === 'TRANSACTION')
          .map(({ column }) => {
            return { field: column, width: 80 };
          })
      : defaultTransactionColumns.map(c => {
          return { field: c, width: 80 };
        });
  }, [userProfile.columnPreferences]);

  if (!params.unitId || !unitNumber) return null;

  return (
    <div className="card-primary">
      <div className="card-header px-3">
        <h4>TRANSACTIONS</h4>
        {[Role.ADMIN, Role.BILLING_ADMIN, Role.BOOKING].includes(userProfile.role) && (
          <div className="flex-fill d-flex justify-content-end g-3">
            <label className="text-info-dark">SHOW DELETED</label>
            <label className="switch">
              <input
                type="checkbox"
                checked={deleted === undefined}
                onChange={e => setDeleted(e.target.checked ? undefined : false)}
              />
              <span className="slider round" />
            </label>
          </div>
        )}
      </div>
      <div className="card-body">
        <DataTable
          columns={transactionDataColumns}
          initialPage={{ sortField: 'completedDate', sortDirection: 'desc' }}
          initialColumns={initialColumns}
          csvFilename="Unit Transactions"
          fetchData={fetchData}
          fetchCsv={downloadTransactionsCsv({ unitNumber, deleted })}
          rowClassName={transaction => (!transaction?.deleted ? '' : 'deleted')}
        />
      </div>
    </div>
  );
};

export default UnitTransactions;
